module.exports = __webpack_public_path__ + "static/media/IMG_1034.f4c986ee.jpg";